// extracted by mini-css-extract-plugin
module.exports = {"root":"EventsPage_root__W_JGU"};